module.exports = __webpack_public_path__ + "static/media/noimage-white.b0c44940.svg";